import { ResourceIndexView } from '@app/types/blackroom-api';

function getAllDescendantIds(
  resourceId: string,
  nestedData: (ResourceIndexView & { subRows?: ResourceIndexView[] })[],
): string[] {
  const findResourceAndDescendants = (
    resources: (ResourceIndexView & { subRows?: ResourceIndexView[] })[],
  ): string[] => {
    for (const resource of resources) {
      if (resource.id === resourceId) {
        const collectAllIds = (
          res: ResourceIndexView & { subRows?: ResourceIndexView[] },
        ): string[] => {
          const ids = [res.id];
          if (res.subRows) {
            res.subRows.forEach((subRow) => {
              ids.push(...collectAllIds(subRow));
            });
          }
          return ids;
        };
        return collectAllIds(resource);
      }
      if (resource.subRows) {
        const found = findResourceAndDescendants(resource.subRows);
        if (found.length > 0) {
          return found;
        }
      }
    }
    return [];
  };

  return findResourceAndDescendants(nestedData);
}

export default getAllDescendantIds;
